(function (module) {
    "use strict";

    module.service("ChartsConfig", ChartsConfig);

    function ChartsConfig(){
        return{
            datasetOverride: [
                {yAxisID: 'y-axis-1'}
                ],
            options: {
                scales: {
                    yAxes: [
                        {
                            id: 'y-axis-1',
                            type: 'linear',
                            display: true,
                            position: 'left',
                            ticks: {
                                beginAtZero: true
                            }
                        }
                    ]
                }
            },
            specialDatasetOverride:[{
                pointBackgroundColor: "rgba(128, 196, 194, 1)",
                pointHoverBackgroundColor: "rgba(128, 196, 194, 0.8)",
                borderWidth: 3,
                fill:false,
                borderColor: "rgba(128, 196, 194, 1)"
            },
                {
                    pointBackgroundColor: "rgba(224,22,22, 1)",
                    borderWidth: 3,
                    fill: false,
                    borderColor: "rgba(224,22,22, 1)",
                    showLine:false
                }]
        };
    }


})(angular.module('topline.services'));